import { Expose, Type } from 'class-transformer'
import { Entity } from '@/app/common/base/entity'
import { SigningProcessConsumer } from './signing-process-consumer.entity'

export class SigningProcessStatus extends Entity<SigningProcessStatus> {
    @Expose({ name: 'consumers' })
    @Type(() => SigningProcessConsumer)
    consumers!: SigningProcessConsumer[]

    @Expose({ name: 'is_same_consumer' })
    isSameConsumer?: boolean

    @Expose({ name: 'is_process_started' })
    isProcessStarted?: boolean

    @Expose({ name: 'is_process_completed' })
    isProcessCompleted?: boolean

    @Expose({ name: 'is_process_expired' })
    isProcessExpired?: boolean

    @Expose({ name: 'is_process_aborted' })
    isProcessAborted?: boolean

    @Expose({ name: 'signing_process_started_at' })
    signingProcessStartedAt?: string

    @Expose({ name: 'signing_process_completed_at' })
    signingProcessCompletedAt?: string

    @Expose({ name: 'message' })
    message?: string
} 